module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "box"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.save($event)
      }
    }
  }, [_c('div', {
    staticClass: "user-container"
  }, [_c('img', {
    staticClass: "comment-icon",
    attrs: {
      "src": _vm.avatar_url
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('span', {
    staticClass: "my-input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.startTimeMins),
      expression: "startTimeMins"
    }],
    staticClass: "my-input text",
    class: _vm.error && 'is-danger',
    attrs: {
      "placeholder": "01",
      "id": "Field8-1",
      "name": "Field8-1",
      "type": "text",
      "value": "",
      "size": "2",
      "maxlength": "2",
      "tabindex": "0"
    },
    domProps: {
      "value": (_vm.startTimeMins)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.startTimeMins = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "my-time-divider"
  }, [_vm._v(":")]), _vm._v(" "), _c('span', {
    staticClass: "my-input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.startTimeSecs),
      expression: "startTimeSecs"
    }],
    staticClass: "my-input text",
    class: _vm.error && 'is-danger',
    attrs: {
      "placeholder": "21",
      "id": "Field8-2",
      "name": "Field8-2",
      "type": "text",
      "value": "",
      "size": "2",
      "maxlength": "2",
      "tabindex": "0"
    },
    domProps: {
      "value": (_vm.startTimeSecs)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.startTimeSecs = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "time-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('span', {
    staticClass: "my-input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.endTimeMins),
      expression: "endTimeMins"
    }],
    staticClass: "my-input text",
    class: _vm.error && 'is-danger',
    attrs: {
      "placeholder": "09",
      "id": "Field8-1",
      "name": "Field8-1",
      "type": "text",
      "value": "",
      "size": "2",
      "maxlength": "2",
      "tabindex": "0"
    },
    domProps: {
      "value": (_vm.endTimeMins)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.endTimeMins = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "my-time-divider"
  }, [_vm._v(":")]), _vm._v(" "), _c('span', {
    staticClass: "my-input-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.endTimeSecs),
      expression: "endTimeSecs"
    }],
    staticClass: "my-input text",
    class: _vm.error && 'is-danger',
    attrs: {
      "placeholder": "57",
      "id": "Field8-2",
      "name": "Field8-2",
      "type": "text",
      "value": "",
      "size": "2",
      "maxlength": "2",
      "tabindex": "0"
    },
    domProps: {
      "value": (_vm.endTimeSecs)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.endTimeSecs = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('textarea', {
    directives: [{
      name: "textautosize",
      rawName: "v-textautosize"
    }, {
      name: "select",
      rawName: "v-select"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.commentText),
      expression: "commentText"
    }],
    staticClass: "textarea",
    class: _vm.error && 'is-danger',
    attrs: {
      "placeholder": "Add a comment..."
    },
    domProps: {
      "value": (_vm.commentText)
    },
    on: {
      "keydown": [function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "esc", 27, $event.key, "Escape")) { return null; }
        _vm.$emit('close')
      }, function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        if (!$event.shiftKey) { return null; }
        return _vm.save($event)
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.commentText = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control flex-space-between"
  }, [_c('button', {
    staticClass: "button is-info",
    class: _vm.addingComment && 'is-loading',
    attrs: {
      "disabled": !_vm.commentText,
      "data-balloon": !_vm.commentText && 'Write something to add a comment.',
      "data-balloon-pos": "right",
      "type": "submit"
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_vm._v("Cancel")])]), _vm._v(" "), (_vm.error) ? _c('p', {
    staticClass: "commenting-error"
  }, [_vm._v("\n        Error creating comment\n      ")]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-4e416d80"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AddComment.vue
// module id = 1032
// module chunks = 0